import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de comedores
 * Maneja todas las operaciones CRUD relacionadas con comedores
 * 
 * NOTA: Los endpoints de comedores ahora usan Python (FastAPI)
 */
export const comedorApi = {
  /**
   * Obtiene todos los comedores o comedores de un proyecto específico
   * @param {number|null} idProyecto - ID del proyecto (opcional)
   * @param {number|null} idComedor - ID del comedor específico (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getAll: (idProyecto = null, idComedor = null) => {
    if (idComedor) {
      // Obtener comedor específico por ID
      return pythonApiClient.get(`/mantenimientos/comedores/${idComedor}`);
    }
    
    // Si hay proyecto, usar endpoint de proyectos
    if (idProyecto) {
      return pythonApiClient.get(`/proyectos/${idProyecto}/comedores`);
    }
    
    // Listar todos los comedores activos
    return pythonApiClient.get('/mantenimientos/comedores');
  },

  /**
   * Obtiene un comedor por ID
   * @param {number} id - ID del comedor
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    return pythonApiClient.get(`/mantenimientos/comedores/${id}`);
  },

  /**
   * Crea un nuevo comedor
   * @param {Object} data - Datos del comedor
   * @param {number} data.id_proyecto - ID del proyecto
   * @param {string} data.nombre - Nombre del comedor
   * @param {boolean} data.activo - Estado del comedor (true=activo, false=inactivo)
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    return pythonApiClient.post('/mantenimientos/comedores', data);
  },

  /**
   * Actualiza un comedor existente
   * @param {number} id - ID del comedor
   * @param {Object} data - Datos actualizados del comedor
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    return pythonApiClient.put(`/mantenimientos/comedores/${id}`, data);
  },

  /**
   * Elimina un comedor
   * @param {number} id - ID del comedor
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    return pythonApiClient.delete(`/mantenimientos/comedores/${id}`);
  },

  /**
   * Obtiene los tipos de servicio asociados a un comedor específico
   * @param {number} comedorId - ID del comedor
   * @returns {Promise} - Respuesta de la API
   */
  getTipoServiciosPorComedor: (comedorId) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/mantenimientos/comedores/${comedorId}/tipo-servicios`);
  },

  /**
   * Obtiene comedores por proyecto (query parameter - para compatibilidad)
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getByProyecto: (proyectoId) => {
    // Usar endpoint de proyectos para obtener comedores
    return pythonApiClient.get(`/proyectos/${proyectoId}/comedores`);
  },

  /**
   * Obtiene comedores por proyecto usando resource nesting (para carga masiva)
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getByProyectoRest: (proyectoId) => {
    // Usar endpoint de proyectos para obtener comedores
    return pythonApiClient.get(`/proyectos/${proyectoId}/comedores`);
  }
};

export default comedorApi;
